
import Api from '@/api'

const fetchTypes = () => {        
    return Api.get('api/types')
};

const fetchWarengruppen = () => {        
    return Api.get('api/warengruppen')
};

export default {
  fetchTypes,
  fetchWarengruppen
};